<template>
	<div class="job-selector-navigation tw-flex">
		<div class="tw-w-1/2 job-selector-navigation-left tw-flex tw-justify-end">
			<template v-if="jobListNavigation">
				<c-job-selector-prev-button
					:disabled="!selectedPrev.name"
					:sub-title="selectedPrev.name"
					@prevClick="$emit('prevItemClick')"
					v-if="currentPage === 1"
				/>
				<c-job-selector-prev-button
					@prevClick="$emit('prevPageClick')"
					v-if="currentPage === 2"
				/>
			</template>
			<template v-if="!jobListNavigation">
				<c-job-selector-prev-button
					@prevClick="$emit('prevPageClick')"
					:disabled="currentPage !== 2"
				/>
			</template>
		</div>
		<div class="tw-w-1/2 job-selector-navigation-right tw-flex tw-justify-start">
			<template v-if="jobListNavigation">
				<c-job-selector-next-button
					@nextClick="$emit('nextPageClick')"
					v-if="currentPage === 1"
				/>
				<c-job-selector-next-button
					v-if="currentPage === 2"
					:disabled="!selectedNext.name"
					:sub-title="selectedNext.name"
					@nextClick="$emit('nextItemClick')"
				/>
			</template>
			<template v-if="!jobListNavigation">
				<c-job-selector-next-button
					@nextClick="$emit('nextPageClick')"
					:disabled="currentPage !== 1"
				/>
			</template>
		</div>
	</div>
</template>

<script>
import cJobSelectorPrevButton from '@/modules/job-profile/components/jobs-profile/job-info-edition/job-selector-prev-button';
import cJobSelectorNextButton from '@/modules/job-profile/components/jobs-profile/job-info-edition/job-selector-next-button';

export default {
	components: {
		cJobSelectorPrevButton,
		cJobSelectorNextButton,
	},
	props: {
		selectedPrev: { default: () => ({}) },
		selectedNext: { default: () => ({}) },
		jobListNavigation: { default: false },
		currentPage: { default: 1 },
	},
	name: 'guideline-job-selector-navigation',
};
</script>

<style lang="scss" scoped>
.job-selector-navigation {
	background-color: #fafafa;
	.job-selector-navigation-left {
		padding: 20px 5px 20px 20px;
	}
	.job-selector-navigation-right {
		padding: 20px 20px 20px 5px;
	}
}
</style>



// WEBPACK FOOTER //
// src/modules/job-profile/components/jobs-profile/job-info-edition/job-selector-navigation.vue